import { createConfirmation } from "react-confirm";
import InputTextDlgWidget from "./InputTextDlgWidget";

export const showInputTextDlgWidget = createConfirmation(InputTextDlgWidget);
